import { useTranslation } from "react-i18next";
import { useGetAssignmentQuery } from "../assignmentsSlice";
import useCreateDialog from "../../dialogs/hooks/useCreateDialog";
import { hasDatePassed, timeDifference } from "../../../utils/dateUtils";

const useAssignmentItem = ({ assignment }) => {
  const { t } = useTranslation();
  const { postNewDialog, creatingDialog } = useCreateDialog();
  const { data: assignmentDetails, isLoading: assignmentDetailsLoading } =
    useGetAssignmentQuery(
      { assignmentId: assignment?.id },
      { skip: assignment?.id === null }
    );

  const handleProblemClick = (problemId) => {
    postNewDialog({ problemId });
  };

  const assignmentLabel = assignment?.topic;
  const assignmentProgress = assignmentDetails?.progress
    ? `(${assignmentDetails?.progress?.solved}/${assignmentDetails?.progress?.total})`
    : "";
  const assignmentCompleted = assignmentDetails?.progress
    ? assignmentDetails?.progress?.solved === assignmentDetails?.progress?.total
    : false;

  let assignedDateLabel;
  let dueDateLabel;
  if (assignmentDetails?.dates) {
    assignedDateLabel = t("assignments.assignedAgo", {
      time: timeDifference(assignmentDetails?.dates?.assigned_at, t),
    });
    if (hasDatePassed(assignmentDetails?.dates?.due_at)) {
      dueDateLabel = t("assignments.dueDatePassed", {
        time: timeDifference(assignmentDetails?.dates?.due_at, t),
      });
    } else {
      dueDateLabel = t("assignments.timeLeft", {
        time: timeDifference(assignmentDetails?.dates?.due_at, t),
      });
    }
  }

  return {
    problems: assignmentDetails?.problems,
    assignmentDetailsLoading,
    assignmentCompleted,
    handleProblemClick,
    creatingDialog,
    assignmentLabel,
    assignmentProgress,
    assignedDateLabel,
    dueDateLabel,
  };
};

export default useAssignmentItem;
